//@flow
import React from 'react';
import {
  makeStyles,
  IconButton,
  ButtonBase,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@material-ui/core';
import SearchInput from '../../../../elements/SearchInput';
import {GetApp, Tune} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';
import {useToggle, useCallbackDebounce} from '../../../../utils/react';
import ContactTableRow from './contact-table-row';
import {useContactSummary} from '../utils/use-contact-summary';
import InlineLoader from '../../../../elements/LoadingSpinner/InlineLoader';
import ContactModalFilter from './ModalFilter';

import {endpoints} from '../api';
import {useState} from 'react';
import {Pagination} from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.75rem',
    borderRadius: '.75rem',
    background: 'white',
    border: `1px solid ${colors.grey300}`,
    position: 'relative',
    minHeight: '400px',
  },
  loader: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(255,255,255,.5)',
  },
  tableContainer: {
    width: '100%',

    overflowX: 'auto',
  },
  channelIcon: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  tableFilters: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '.5rem',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      flexDirection: 'row',
    },
  },
  filters: {
    display: 'flex',
    gap: '.5rem',
  },
  filterButton: {
    padding: '.5rem .75rem',
    display: 'flex',
    gap: '.5rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '2rem',
    color: colors.grey700,
    border: `1px solid ${colors.grey300}`,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '1rem',
  },
  noContactsMessage: {
    color: colors.grey500,
    marginTop: '1rem',
  },
}));

function formatQueryDate(rawDate: any) {
  if (!rawDate) return undefined;

  const date = new Date(rawDate);

  const formattedDate = date.toISOString().split('T')[0];
  return formattedDate;
}

export default function ContactTable() {
  const classes = useStyles();

  const [filtersOpen, toggleFiltersOpen] = useToggle(false);

  const {
    contacts,
    loading,
    pagination,
    setFilterContacts,
  } = useContactSummary();

  // Filters states
  const [selectedTags, setSelectedTags] = useState([]);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedChannel, setSelectedChannel] = useState();

  const [lastMessageDate, setLastMessageDate] = useState();
  const [selectedState, setSelectedState] = useState();
  // ---

  const handleApplyFilters = () => {
    console.log({
      channel: selectedChannel,
      tags: selectedTags,
      startDate: formatQueryDate(startDate),
      createdFrom: formatQueryDate(startDate),
      createdTo: formatQueryDate(endDate),
      lastMessageDate: formatQueryDate(lastMessageDate),
      state: selectedState,
      status: selectedState,
    });
    setFilterContacts({
      channel: selectedChannel,
      tags: selectedTags,
      startDate: formatQueryDate(startDate),
      createdFrom: formatQueryDate(startDate),
      createdTo: formatQueryDate(endDate),
      lastMessageDate: formatQueryDate(lastMessageDate),
      state: selectedState,
      status: selectedState,
    });

    toggleFiltersOpen();
  };

  const clearFilters = () => {
    setFilterContacts({
      channel: undefined,
      tags: [],
      startDate: undefined,
      createdFrom: undefined,
      createdTo: undefined,
      lastMessageDate: undefined,
      state: undefined,
      status: undefined,
    });
    toggleFiltersOpen();
  };

  const setPagination = page => {
    setFilterContacts({
      page,
    });
  };

  const handleSearchChange = useCallbackDebounce(
    value => {
      console.log(value);
      setFilterContacts({
        name: value || undefined,
      });
    },
    [],
    500
  );

  return (
    <aside className={classes.root}>
      {loading && (
        <div className={classes.loader}>
          <InlineLoader loading size={40} />
        </div>
      )}

      {/* {!haQuickRepliesFeature && ( */}

      {/* )} */}
      <div className={classes.tableFilters}>
        <SearchInput
          placeholder="Buscar cliente por nombre"
          onChange={handleSearchChange}
        />

        <div className={classes.filters}>
          <ButtonBase
            className={classes.filterButton}
            onClick={toggleFiltersOpen}
          >
            <Tune fontSize="small" />
            <span>Filtros</span>
          </ButtonBase>
          <a
            href={endpoints.EXPORT_CONTACT_SUMMARY}
            download
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Descargar resumen de contactos"
          >
            <IconButton color="primary">
              <GetApp />
            </IconButton>
          </a>
        </div>
      </div>

      <div className={classes.tableContainer}>
        {contacts.length === 0 && (
          <Typography
            variant="body1"
            align="center"
            className={classes.noContactsMessage}
          >
            No se encontraron contactos
          </Typography>
        )}
        {contacts.length > 0 && (
          <Table className={classes.table} aria-label="tabla de contactos">
            <TableHead>
              <TableRow>
                <TableCell>Creación</TableCell>
                <TableCell>Nombre de Contacto</TableCell>
                <TableCell align="left">Compras</TableCell>
                <TableCell align="left">Canales de comunicación</TableCell>
                <TableCell align="left">Mensajes Pendientes</TableCell>
                <TableCell align="left">Etiquetas de Conversación</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contacts.map(contact => (
                <ContactTableRow contact={contact} key={contact.id} />
              ))}
            </TableBody>
          </Table>
        )}
        {pagination && (
          <footer className={classes.footer}>
            <Pagination
              count={
                pagination &&
                (pagination.size >= pagination.total
                  ? 1
                  : Math.ceil(pagination.total / pagination.size))
              }
              page={pagination.page + 1}
              className={classes.pagination}
              color="primary"
              onChange={(e, page) => {
                setPagination(page - 1);
              }}
            />
          </footer>
        )}
      </div>

      <ContactModalFilter
        open={filtersOpen}
        onClose={toggleFiltersOpen}
        onApply={handleApplyFilters}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        selectedChannel={selectedChannel}
        setSelectedChannel={setSelectedChannel}
        lastMessageDate={lastMessageDate}
        setLastMessageDate={setLastMessageDate}
        selectedState={selectedState}
        setSelectedState={setSelectedState}
        onClear={clearFilters}
      />
    </aside>
  );
}
